import { ICON_SIZES } from 'lib/constants/iconSizes';

const WeightWatchers = ({ svgSize = ICON_SIZES.MD, className = '' }) => {
  return (
    <svg
      width={svgSize}
      height={svgSize}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_ww)">
        <mask
          id="mask0_ww"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="32"
          height="32"
        >
          <path d="M32 0H0V32H32V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_ww)">
          <path
            d="M15.9599 32.08C24.8186 32.08 31.9999 24.8986 31.9999 16.04C31.9999 7.18135 24.8186 0 15.9599 0C7.10127 0 -0.0800781 7.18135 -0.0800781 16.04C-0.0800781 24.8986 7.10127 32.08 15.9599 32.08Z"
            fill="#0222D0"
          />
          <mask
            id="mask1_ww"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="11"
            y="3"
            width="10"
            height="26"
          >
            <path d="M20.4298 3.20801H11.4563V28.6253H20.4298V3.20801Z" fill="white" />
          </mask>
          <g mask="url(#mask1_ww)">
            <path
              d="M17.403 3.20801L17.2286 9.91615H17.1049L16.8867 3.20801H15.101L14.8974 9.90882H14.7671L14.6075 3.20801H12.7419L13.5839 13.4664H15.7329L15.8998 7.62226H16.0308L16.1977 13.4664H18.3035L19.1456 3.20801H17.403Z"
              fill="white"
            />
            <path
              d="M17.403 18.3601L17.2286 25.0683H17.1049L16.8867 18.3601H15.101L14.8974 25.0611H14.7671L14.6075 18.3601H12.7419L13.5839 28.6187H15.7329L15.8998 22.7743H16.0308L16.1977 28.6187H18.3035L19.1456 18.3601H17.403Z"
              fill="white"
            />
            <path d="M20.4298 15.0999H11.4563V16.726H20.4298V15.0999Z" fill="white" />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_ww">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

WeightWatchers.propTypes = {
  className: PropTypes.string,
};

export default WeightWatchers;
